export const GET_DISCONNECT_CONDITIONS = 'NURSERY_INTEGRATIONS/GET_DISCONNECT_CONDITIONS'
export const GET_DISCONNECT_CONDITIONS_SUCCESS = 'NURSERY_INTEGRATIONS/GET_DISCONNECT_CONDITIONS_SUCCESS'
export const GET_DISCONNECT_CONDITIONS_FAILED = 'NURSERY_INTEGRATIONS/GET_DISCONNECT_CONDITIONS_FAILED'
